import { render, staticRenderFns } from "./LayoutPublicProducts.vue?vue&type=template&id=3835b3ed&lang=pug&"
import script from "./LayoutPublicProducts.vue?vue&type=script&lang=ts&"
export * from "./LayoutPublicProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports